import utils from '@/common/util/utils'
import { parseUrl } from 'query-string'
import { get } from 'lodash'
// 1. path 가 home 인지
// 2. 미로그인 유저저인지
// 3. 1,2 의 조건이 모두 충족 되는지
// 중족되면 location.replace 로 강제 이동 하는데, referer..는 포함하지 않는다.
// 이유는 원래 홈 일때만 동작 하게 되어 있었으니까

const PATH_COVER_PAGE = '/cover'

export function checkMoveCoverPage () {
  const isLoginUser = utils.cookies.getCredential() !== 'none'
  const isHomePath = location.pathname === '/' || location.pathname === ''
  const { query } = parseUrl(location.href)
  const isPassCover = get(query, 'pass', 'n').toLowerCase() === 'y'
  return !isLoginUser && isHomePath && !isPassCover
}

export function goCoverPage () {
  window.location.replace(PATH_COVER_PAGE + location.search)
}
